import { toast } from "react-toastify";
import { ContactAPI } from "../constants/apiRoutes";
import { contactActions } from "../reducers/contact";
import apiService from "../utils/configAxios";
import { handleError } from "../utils/handleError";

export const fetchContactList = () => {
  return (dispatch) => {
    return apiService
      .get(ContactAPI.list())
      .then((response) => {
        dispatch(contactActions.fetchContactList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchEducatorContactList = () => {
  return (dispatch) => {
    return apiService
      .get(ContactAPI.educatorList())
      .then((response) => {
        dispatch(contactActions.fetchEducatorContactList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchContactById = (id = 0) => {
  return (dispatch) => {
    return apiService
      .get(ContactAPI.getById(id))
      .then((response) => {
        dispatch(contactActions.fetchContactDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};
